import React from 'react';
import {Box, Typography, FormControlLabel, Checkbox, makeStyles} from '@material-ui/core';
import {BankVerificationState} from '@/APIs/types';

interface BankVerificationErrorProps {
    verificationResult: {
        verificationId: string;
        state: BankVerificationState;
    } | null;
    overrideConfirmed: boolean;
    onOverrideChange: (checked: boolean) => void;
}

const useStyles = makeStyles(() => ({
    errorBox: {
        marginTop: '12px',
        padding: '16px',
        backgroundColor: '#FFF5F5',
        border: '1px solid #F65858',
        borderRadius: '8px',
    },
    errorTitle: {
        fontFamily: 'Fredoka',
        fontWeight: 500,
        fontSize: '16px',
        lineHeight: '160%',
        color: '#F65858',
        marginBottom: '8px',
    },
    errorMessage: {
        fontFamily: 'Fredoka',
        fontWeight: 400,
        fontSize: '15px',
        lineHeight: '160%',
        color: '#F65858',
    },
    overrideCheckbox: {
        marginTop: '12px',
        '& .MuiFormControlLabel-label': {
            fontFamily: 'Fredoka',
            fontWeight: 400,
            fontSize: '14px',
            color: '#434343',
        },
    },
}));

export function BankVerificationError({
    verificationResult,
    overrideConfirmed,
    onOverrideChange,
}: BankVerificationErrorProps) {
    const classes = useStyles();

    if (!verificationResult || verificationResult.state === BankVerificationState.PASS) {
        return null;
    }

    return (
        <>
            <Box className={classes.errorBox}>
                <Typography className={classes.errorTitle}>We were unable to verify your bank information</Typography>
                <Typography className={classes.errorMessage}>
                    Unfortunately we were unable to verify your bank account, please correct your info to confirm this
                    is correct.
                </Typography>
            </Box>
            {verificationResult.state === BankVerificationState.PREVENT_NEXT_WITH_OVERRIDE && (
                <FormControlLabel
                    className={classes.overrideCheckbox}
                    control={
                        <Checkbox
                            checked={overrideConfirmed}
                            onChange={(e) => onOverrideChange(e.target.checked)}
                            color="primary"
                        />
                    }
                    label="I acknowledge the bank information failed validation but confirm the information is correct."
                />
            )}
        </>
    );
}
